import { render } from "./LegacyEvent.vue?vue&type=template&id=1b58e758"
import script from "./LegacyEvent.vue?vue&type=script&lang=js"
export * from "./LegacyEvent.vue?vue&type=script&lang=js"
script.render = render

export default script